import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiVersionInterceptor {
  private baseURL: URL = new URL(environment.baseUrl);
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.isSameDestination(request.url)) {
      request = this.addVersion(request, environment.baseUrlVersion);
      return next.handle(request);
    }

    // do process as normal request
    return next.handle(request);
  }

  private isSameDestination(path: string): boolean {
    let targetURL = new URL(path);
    return (
      targetURL.host === this.baseURL.host &&
      targetURL.protocol === this.baseURL.protocol
    );
  }

  private addVersion(request: HttpRequest<any>, version: string) {
    return request.clone({
      setHeaders: {
        'Accept-Version': version,
      },
    });
  }
}
